import { PgReader } from './pgreader';
import { Util } from './util';
import { Page, WpConst } from '../types/wptypes';
import { LoadState } from '../types/commontypes';
import { AnimationManager } from "./animmanager";

const enum GenerateState {
  None = 0,
  Generating = 1,
}

export class Thumbnail {

  private reader: PgReader

  private twidth: number  //thumbnail width
  private theight: number //thumbnail height
  private generatingIndex: number
  private items: HTMLDivElement[]
  private pages: Page[]

  private offscreenCanvas: HTMLCanvasElement
  private state: { [index: number]: any } //generating thumbnail state

  public reset(reader: PgReader, loadedPageIndex: number) {
    this.reader = reader
    this.pages = reader.doc.pages
    this.state = Object.create(null)
    let leftpanel = document.getElementById('pg-leftpanel')
    // while (leftpanel.childElementCount) leftpanel.lastElementChild.remove()
    let gap = 10
    let itemWidth = this.twidth = WpConst.pgLeftpanel - 30
    let itemHeight = this.theight = itemWidth * reader.doc.pagesize.height / reader.doc.pagesize.width
    let count = reader.doc.pageCount
    if (!this.items) {
      this.items = []
    }
    let items = this.items
    let onItemClick = (e) => {
      e = e || window.event
      // IE9 和 IE10 不謙容 pointerEvents：none，所有下面e.target会指向子元素
      let index = e.target.getAttribute('data-index') || e.target.parentNode.getAttribute('data-index')
      reader.deleteMenu()
      // reader.gotoPage(index)
      console.log(index)
      AnimationManager.instance.gotoAnimation({
        pageIndex: index,
        animationId: 0,
        type: 'pre'
      })
    }
    for (let i = loadedPageIndex; i < count; i++) {
      let item = document.createElement('div')
      item.className = 'totalPageNomal'
      item.style.width = itemWidth + 'px'
      item.style.height = itemHeight + 'px'
      item.style.margin = '0 auto'
      item.style.marginBottom = gap + 'px'
      item.style.marginTop = gap + 'px'
      item.style.position = 'relative'
      item.setAttribute('data-index', '' + i)
      item.onclick = onItemClick
      // 每个小缩略图都要添加播放按钮
      if ((reader.doc.param as any).showLeftAnimation) {
        let sidePlay = document.createElement('img');
        sidePlay.className = 'sidePlay';
        sidePlay.src = './ppt/sideplay.svg';
        sidePlay.onclick = () => PgReader.instance.setFullScreen(false);
        item.appendChild(sidePlay);
      }
      leftpanel.appendChild(item);
      items.push(item)
    }

    this.items = items

    this.generateThumbnail(loadedPageIndex)

  }
  private async generateThumbnail(pageIndex: number) {
    if (pageIndex >= this.pages.length) return
    let state = this.state
    if (state[pageIndex] == GenerateState.Generating) {
      return
    }
    state[pageIndex] = GenerateState.Generating
    let reader = this.reader
    let page = this.pages[pageIndex]
    let needRepaint
    if (page.state != LoadState.Loading) {
      needRepaint = true
      page.state = LoadState.Loading
      await reader.loadPage(page, false)
      await reader.forceLoadPageResourceForPrint(page)
    }
    let canvas = this.offscreenCanvas
    if (!canvas) {
      canvas = this.offscreenCanvas = Util.createCanvas(page.width, page.height)
    }
    let g = canvas.getContext('2d')
    g.save()
    g.fillStyle = '#FFFFFF'
    g.strokeStyle = '#CECECE'
    g.fillRect(0, 0, canvas.width, canvas.height)
    g.strokeRect(0, 0, canvas.width, canvas.height)
    g.beginPath()
    g.rect(0, 0, canvas.width, canvas.height)
    g.clip()
    g.translate(0, 0)
    reader.paintPage(g, page, undefined, true)
    g.restore()

    let width = this.twidth, height = this.theight
    let item = this.items[pageIndex]
    let itemCanvas = Util.createCanvas(width, height)
    itemCanvas.style.pointerEvents = 'none'
    itemCanvas.style.cursor = 'default'
    let itemg = itemCanvas.getContext('2d')
    itemg.imageSmoothingQuality = 'medium'
    itemg.drawImage(canvas, 0, 0, width, height)
    item.appendChild(itemCanvas)
    requestAnimationFrame(() => this.generateThumbnail(++pageIndex))
    if (needRepaint) {
      requestAnimationFrame(() => reader.paint())
    }
  }
}